/**
 * axios setup to use mock service
 */

import axios from 'axios';

// Environment-aware configuration - works for dev and production
export const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

// Create axios instance with environment-aware base URL
const axiosServices = axios.create({ baseURL: BASE_URL });

// interceptor for http
axiosServices.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject((error.response && error.response.data) || 'Wrong Services')
);

export default axiosServices;
